  var sliders = document.querySelectorAll('.js-video-carousel');

  sliders.forEach(function (slider, index) {
    let uniqueClass = 'js-video-carousel-index-' + (index + 1);
    slider.classList.add(uniqueClass);

    // Initialize Swiper using the unique class
    new Swiper('.' + uniqueClass, {
      loop: true,
      pagination: {
        el: slider.querySelector('.swiper-pagination'),
        clickable: true,
      },
      breakpoints: {
        640: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20,
        }
      },
      navigation: {
        nextEl: slider.querySelector('.swiper-button-next'),
        prevEl: slider.querySelector('.swiper-button-prev'),
      },
    });
  });
